import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of as observableOf, Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { Constants } from '../core/constants';


@Injectable()
export class CustomerAccountService {

  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService,
    private constants: Constants, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getByCustomerId(customerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `customeraccount/customer/${customerId}`).pipe(
      map((res: Response) => this.addDisplayDataForRows(res)),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getByAccountId(generalLedgerId: number, accountId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `customeraccount/accountid/${accountId}?generalLedgerId=${generalLedgerId}`).pipe(
      map((res: Response) => this.addCustomerAccountDisplayData(res)),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getByAccountNo(accountNo: string, applicationModuleId = this.constants.ApplicationModule.Unknown,
    specialSearch = this.constants.SpecialSearch.Unknown): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `customeraccount/account/${accountNo}?applicationModuleId=${applicationModuleId}&&specialSearch=${specialSearch}`).pipe(
        map((res: Response) => this.addCustomerAccountDisplayData(res)),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFiltered(filter: string, applicationModuleId: number, specialSearch: number, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean): Observable<any> {
    const params = {
      filter, applicationModuleId, specialSearch, pageIndex, pageSize, sortColumn, sortAscending
    };

    return this.httpClient.post(this.baseApiUrl + 'customeraccount/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  addCustomerAccountDisplayData(customerAccount: any): any {
    const additionalData = JSON.parse(customerAccount.additionalData);
    customerAccount.displayData = `${customerAccount.customerName} - ${customerAccount.customerIdentifier}`
      + ` - ${customerAccount.aadharNumber} - ${customerAccount.panNumber} - ${customerAccount.mobileNumber}`;
    return customerAccount;
  }

  addDisplayDataForRows(customerAccount: any): any {
    customerAccount.forEach(customer => {
      if (customer !== null && customer.displayData === null) {
        customer.displayData = `${customer.customerName} - ${customer.customerIdentifier}`
          + ` - ${customer.aadharNumber} - ${customer.panNumber} - ${customer.mobileNumber}`;
      }
    });
    return customerAccount;
  }

  goToAccountDetails(applicationModule: number, accountId: number) {
    switch (applicationModule) {
      case this.constants.ApplicationModule.LoanEMI:
        window.open(`/loanaccount/detail/${accountId}`);
        break;
      case this.constants.ApplicationModule.SavingsAccount:
        window.open(`/casaaccount/detail/${accountId}`);
        break;
      case this.constants.ApplicationModule.Shares:
        window.open(`/shareaccount/detail/${accountId}`);
        break;
      case this.constants.ApplicationModule.Overdraft:
        window.open(`/overdraftaccount/detail/${accountId}`);
        break;
    }
  }

  public goToCustomerDetails(customerId: number) {
    window.open(`/customer/detail/${customerId}`);
  }

  public getAccountNoAndGeneralLedger(account: any): string {
    return `${account.accountNo} / ${account.generalLedgerDescription} - ${account.generalLedgerCode}`;
  }

  public getCustomerNameAndId(account: any): string {
    return `${account.customerName} - ${account.customerIdentifier}`;
  }

  updateMinimumBalance(dataSource: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + `customeraccount/updateminimumBalance`, dataSource).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
}
getAccountsdelete(applicationModule: number): Observable<any> {
  return this.httpClient.get(this.baseApiUrl +
    `customeraccount/deleteccount?applicationModule=${applicationModule}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
}
}
